import { render, staticRenderFns } from "./CareCampusUniChecklistDetail.vue?vue&type=template&id=61f6ad16&scoped=true&"
import script from "./CareCampusUniChecklistDetail.vue?vue&type=script&lang=js&"
export * from "./CareCampusUniChecklistDetail.vue?vue&type=script&lang=js&"
import style0 from "./CareCampusUniChecklistDetail.vue?vue&type=style&index=0&id=61f6ad16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6ad16",
  null
  
)

export default component.exports